/* In the Wild live stock check (Daniel 2026-10-01: display by rules, never by baked data).
   Rows carry data-itw-handle. On every visit we read live stock from /products.json (all published
   products, ~4 requests, cached 10 minutes), hide any row that is not for sale, reveal rows that came
   back, and fix each look's item count. A look with nothing left for sale loses its Shop button.
   If the stock read fails, the page keeps its server-rendered state (rows baked as sold out stay hidden). */
(function () {
  var rows = document.querySelectorAll('[data-itw-handle]');
  if (!rows.length) return;
  var KEY = 'an-instock-v1', TTL = 10 * 60 * 1000;
  function cached() {
    try { var c = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (c && Date.now() - c.t < TTL) return c.m; } catch (e) {}
    return null;
  }
  function load() {
    var m = cached(); if (m) return Promise.resolve(m);
    m = {};
    function page(n) {
      return fetch('/products.json?limit=250&page=' + n, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function (d) {
          var ps = d.products || [];
          ps.forEach(function (p) { m[p.handle] = (p.variants || []).some(function (v) { return v.available; }); });
          return ps.length === 250 && n < 12 ? page(n + 1) : m;
        });
    }
    return page(1).then(function (map) { try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), m: map })); } catch (e) {} return map; });
  }
  load().then(function (live) {
    rows.forEach(function (row) {
      var ok = live[row.getAttribute('data-itw-handle')] === true;
      if (!ok) { row.hidden = true; return; }
      row.hidden = false;
      var sold = row.querySelector('.itw-add.is-sold');
      if (sold) { var a = document.createElement('a'); a.className = 'itw-add'; a.href = (row.querySelector('.itw-view') || {}).href || '#'; a.textContent = 'Choose options'; sold.replaceWith(a); }
    });
    document.querySelectorAll('.itw-look').forEach(function (look) {
      var all = look.querySelectorAll('.itw-prod'); if (!all.length) return;
      var n = 0; all.forEach(function (r) { if (!r.hidden) n++; });
      var trig = look.querySelector('.itw-trigger'), hint = look.querySelector('[data-itw-count]'), lab = look.querySelector('[data-itw-count-label]');
      if (hint && hint.lastChild && hint.lastChild.nodeType === 3) hint.lastChild.nodeValue = String(n);
      if (lab) lab.textContent = 'Shop this look: ' + n + ' item' + (n === 1 ? '' : 's');
      if (trig) trig.hidden = n === 0;
      if (n === 0) { var panel = look.querySelector('.itw-panel'); if (panel) panel.hidden = true; }
    });
  }).catch(function () {});
})();
